// extracted by mini-css-extract-plugin
export default {"EditeTemplateDiv":"EditeTemplate_EditeTemplateDiv__48kIn","title":"EditeTemplate_title__SYp4J"};